module.exports = __webpack_public_path__ + "static/sketch-svg.c397f502.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/features/sketch-svg.jpg
// module id = 1001
// module chunks = 72138227098318